import React from "react";
import { NotificationDetailBody } from "tsi-common-react/src/apps/customer-account/NotificationDetailBody/index";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.NotificationDetailDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <NotificationDetailBody {...props} />
    </PageSkeleton>
);
